import { AxiosPromise } from "axios";
import service from "../apis/Service";
import DtoPageListSearchCompanyFollowUpRecord from "../models.machine/DtoPageListSearchCompanyFollowUpRecord";
import RESTfulResult from "../models.machine/RESTfulResult";
import DtoPageListCompanyFollowUpRecord from "../models.machine/DtoPageListCompanyFollowUpRecord";
import DtoDetailCompanyFollowUpRecord from "../models.machine/DtoDetailCompanyFollowUpRecord";
import DtoFormCompanyFollowUpRecord from "../models.machine/DtoFormCompanyFollowUpRecord";
import { EnumCompanyType, EnumCompanyTypeOption } from "../models.machine/EnumCompanyType";
import UiSelectOptionWithStringValue from "../models.machine/UiSelectOptionWithStringValue";

/**
 * 跟进记录
 * @description 自动生成的代码,请勿修改
 */
export default class CompanyFollowUpRecordAppService {
    /**
     * 获取跟进记录分页列表
     * @param {DtoPageListSearchCompanyFollowUpRecord} [dto] 搜索条件
     * @returns {AxiosPromise<RESTfulResult<DtoPageListCompanyFollowUpRecord>>} 分页列表
     */
    static Get(dto?: DtoPageListSearchCompanyFollowUpRecord): AxiosPromise<RESTfulResult<DtoPageListCompanyFollowUpRecord>> {
        const url = `/api/CompanyFollowUpRecord/Get`;
        return service.get<RESTfulResult<DtoPageListCompanyFollowUpRecord>>(url, { params: dto });
    }

    /**
     * 获取跟进记录详细
     * @param {string} [id] Id
     * @returns {AxiosPromise<RESTfulResult<DtoDetailCompanyFollowUpRecord>>} 详细
     */
    static GetById(id?: string): AxiosPromise<RESTfulResult<DtoDetailCompanyFollowUpRecord>> {
        const url = `/api/CompanyFollowUpRecord/Get/${id}`;
        return service.get<RESTfulResult<DtoDetailCompanyFollowUpRecord>>(url);
    }

    /**
     * 添加跟进记录
     * @param {DtoFormCompanyFollowUpRecord} [dto] 表单
     * @returns {AxiosPromise<RESTfulResult<string>>} Id
     */
    static Post(dto?: DtoFormCompanyFollowUpRecord): AxiosPromise<RESTfulResult<string>> {
        const url = `/api/CompanyFollowUpRecord/Post`;
        return service.post<RESTfulResult<string>>(url, dto);
    }

    /**
     * 批量删除跟进记录
     * @param {string[]} [ids] Id
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static Delete(ids?: string[]): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/CompanyFollowUpRecord/Delete`;
        return service.delete<RESTfulResult<any>>(url, { data: ids });
    }

    /**
     * 校验是否存在
     * @param {string} [id] 
     * @param {EnumCompanyType} [companyType] 
     * @param {string} [customerLabel] 
     * @param {Date} [planFollowUpTime] 
     * @returns {AxiosPromise<RESTfulResult<boolean>>} 
     */
    static CheckExist(id?: string, companyType?: EnumCompanyType, customerLabel?: string, planFollowUpTime?: Date): AxiosPromise<RESTfulResult<boolean>> {
        const url = `/api/CompanyFollowUpRecord/CheckExist`;
        const _querys: any = {};
        _querys.id = id
        _querys.companyType = companyType
        _querys.customerLabel = customerLabel
        _querys.planFollowUpTime = planFollowUpTime
        return service.post<RESTfulResult<boolean>>(url, undefined, { params: _querys });
    }

    /**
     * 获取历史记录
     * @param {EnumCompanyType} [companyType] 
     * @param {string} [name] 
     * @returns {AxiosPromise<RESTfulResult<UiSelectOptionWithStringValue[]>>} 
     */
    static GetHistory(companyType?: EnumCompanyType, name?: string): AxiosPromise<RESTfulResult<UiSelectOptionWithStringValue[]>> {
        const url = `/api/CompanyFollowUpRecord/GetHistory`;
        const _querys: any = {};
        _querys.companyType = companyType
        _querys.name = name
        return service.get<RESTfulResult<UiSelectOptionWithStringValue[]>>(url, { params: _querys });
    }

    /**
     * 删除历史记录
     * @param {EnumCompanyType} [companyType] 
     * @param {string} [name] 
     * @param {string} [value] 
     * @returns {AxiosPromise<RESTfulResult<any>>} 
     */
    static DeleteHistory(companyType?: EnumCompanyType, name?: string, value?: string): AxiosPromise<RESTfulResult<any>> {
        const url = `/api/CompanyFollowUpRecord/DeleteHistory`;
        const _querys: any = {};
        _querys.companyType = companyType
        _querys.name = name
        _querys.value = value
        return service.delete<RESTfulResult<any>>(url, { params: _querys });
    }

}
